const errorMessages = {
    400: 'Bad Request. Please check your input and try again.',
    401: 'Unauthorized. Please log in to continue.',
    403: 'Forbidden. You do not have permission to access this resource.',
    404: 'Not Found. The requested resource could not be found.',
    405: 'Method Not Allowed. Please check the request method and try again.',
    406: 'Not Acceptable. The requested resource is not available in a format acceptable to your browser.',
    407: 'Proxy Authentication Required. Please authenticate with the proxy server.',
    408: 'Request Timeout. Please try again later.',
    409: 'Conflict. The request could not be completed due to a conflict with the current state of the resource.',
    500: 'Internal Server Error. Please try again later.',
    502: 'Bad Gateway. The server received an invalid response.',
    503: 'Service Unavailable. Please try again later.',
    504: 'Gateway Timeout. The server took too long to respond.',
    downloadError: 'An error occurred during the download process',
    uploadError: 'An error occurred during the upload process',
    requiredYAMLContent: 'YAML content is required. Please provide valid content.',
    requiredYAMLFileContent: 'The selected file is empty',
    errorReadingFile: 'Error reading file',
    creatingArchiveError: 'An error occurred while creating the archive',
    offline: `Uh oh! It looks like you've lost your internet connection.  Try checking your network settings`,
    unknown: 'An unknown error occurred',
    failedToCopy: 'Failed to copy to clipboard.',
    resourceCreationFailed: 'Resource creation failed. Please try again.',
};

const successMessages = {
    created: 'Created successfully.',
    updated: 'Updated successfully.',
    deleted: 'Deleted successfully.',
    assigned: 'Assigned successfully.',
    unassigned: 'Unassigned successfully.',
    uploaded: 'File uploaded successfully.',
    downloaded: 'File downloaded successfully.',
    backOnline: 'You are back online.',
    accepted: 'Accepted successfully.',
    rejected: 'Rejected successfully.',
    requested: 'Requested successfully.',
    promoted: 'Promoted successfully.',
    reset: 'Reset successfully.',
    revoked: 'Revoked successfully.',
    copiedToClipboard: 'Copied to clipboard.',
    datasetUploadSuccess:
        'Upload successful. File processing may take a few moments. Please refresh the page if files do not appear immediately.',
};

const infoMessages = {
    cancelled: 'Operation cancelled.',
    useBulkCopy: 'This workflow is of type Bulk Copy. Please use the Remote File Manager to manage this workflow.',
};

export { errorMessages, successMessages, infoMessages };
